import React from "react";
import { Modal, Button } from "react-bootstrap";

class EmailAddressPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      errorMSG: ""
    };
  }

  _handleClose = () => {
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  }

  render() {
    return (
      <div>
        <Modal show={this.props.open} backdrop={true}>
          <Modal.Header closeButton={true} onHide={() => this._handleClose()}>
            <Modal.Title>Email Address</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              type="email"
              className="form-control"
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
              placeholder="Enter Email Address"
            />
            <span style={{ color: "red", padding: 10 }}>{this.state.errorMSG}</span>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <Button
                bsStyle="primary"
                onClick={e => {
                  this._handleSubmit(e);
                }}
              >
                Submit
              </Button>
              <Button
                className="m-l-5p"
                type="submit"
                bsStyle="default"
                onClick={() => {
                  this.props.onClose();
                }}
              >
                Cancel
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
  _handleSubmit(e) {
    e.preventDefault();
    var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if (reg.test(this.state.email)) {
      this.props.onSubmit(this.state.email);
      this.props.onClose();
    } else {
      this.setState({ errorMSG: "Invalid Email Address" });
    }
  }

  // static propTypes = {
  //   open: PropTypes.bool.isRequired,
  //   onClose: PropTypes.func.isRequired,
  //   onSubmit: PropTypes.func.isRequired
  // };
}

export default EmailAddressPopup;
